import { Text } from 'react-native';

function getGreeting(date: Date = new Date()): string {
  const hour = date.getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}

interface DashboardGreetingProps {
  firstName: string | null | undefined;
}

/**
 * Single-line time-of-day greeting at the top of the dashboard.
 * The avatar/menu lives in the global mobile top bar (see MobileTopBar).
 */
export function DashboardGreeting({ firstName }: DashboardGreetingProps) {
  const display = (firstName ?? '').trim() || 'there';
  return (
    <Text
      className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4"
      numberOfLines={1}
    >
      {getGreeting()}, {display}
    </Text>
  );
}
